import { Injectable } from '@angular/core';
import { PlanMetadataTypes } from '@mode/shared/contract-common';
import { DEFAULT_FLAMINGO_PAGE_SIZE, makeVizDesignerPlanMetadataId } from '@mode/shared/util-js';
import { PlanMetadataActions, PlanMetadataFacade } from '@mode/switch-views/contract';
import { Store } from '@ngrx/store';
import { PlanMetadataFeatureState } from './plan-metadata/plan-metadata.reducer';
import {
  getOffsetByMetadataId,
  getPageSizeByMetadataId,
  getPlanPagingByMetadataId,
} from './plan-metadata/plan-metadata.selectors';

@Injectable()
export class PlanMetadataService implements PlanMetadataFacade {
  constructor(private store: Store<PlanMetadataFeatureState>) {
    // init observables
  }

  /**
   * Observables
   */

  /**
   * Observable creators
   */
  createPagingSelector(planMetadataId: PlanMetadataTypes.PlanMetadataId) {
    return this.store.select(getPlanPagingByMetadataId(planMetadataId));
  }

  createOffsetSelector(planMetadataId: PlanMetadataTypes.PlanMetadataId) {
    return this.store.select(getOffsetByMetadataId(planMetadataId));
  }

  createPageSizeSelector(planMetadataId: PlanMetadataTypes.PlanMetadataId) {
    return this.store.select(getPageSizeByMetadataId(planMetadataId));
  }

  /**
   * Action dispatchers
   */

  /** Initialize paging - overrides any existing entity */
  initPaging(planMetadataId: PlanMetadataTypes.PlanMetadataId, offset = 0, pageSize = DEFAULT_FLAMINGO_PAGE_SIZE) {
    this.store.dispatch(
      PlanMetadataActions.initPaging({
        planMetadataId,
        offset,
        pageSize,
      })
    );
  }

  /** Initialize paging - does nothing if entity already exists */
  initPagingIfUnset(
    planMetadataId: PlanMetadataTypes.PlanMetadataId,
    offset = 0,
    pageSize = DEFAULT_FLAMINGO_PAGE_SIZE
  ) {
    this.store.dispatch(
      PlanMetadataActions.initPagingIfUnset({
        planMetadataId,
        offset,
        pageSize,
      })
    );
  }

  /** Generic setOffset - requires the proper plamMetadataId to be passed */
  setOffsetInDesigner(vizToken: string, offset: number) {
    this.store.dispatch(
      PlanMetadataActions.setOffsetInDesigner({
        planMetadataId: makeVizDesignerPlanMetadataId(vizToken),
        vizToken,
        offset,
      })
    );
  }

  setPageSizeInDesigner(vizToken: string, pageSize: number, offset = 0) {
    this.store.dispatch(
      PlanMetadataActions.setPageSizeInDesigner({
        planMetadataId: makeVizDesignerPlanMetadataId(vizToken),
        vizToken,
        pageSize,
        offset,
      })
    );
  }

  setOffsetRawResults(queryToken: string, offset: number) {
    this.store.dispatch(
      PlanMetadataActions.setOffsetRawResults({
        queryToken,
        offset,
      })
    );
  }

  setOffsetWithCalcs(queryToken: string, offset: number) {
    this.store.dispatch(
      PlanMetadataActions.setOffsetWithCalcs({
        queryToken,
        offset,
      })
    );
  }
}
